import { render, staticRenderFns } from "./serviceContractMag.vue?vue&type=template&id=62c0f0bc&scoped=true&"
import script from "./serviceContractMag.vue?vue&type=script&lang=js&"
export * from "./serviceContractMag.vue?vue&type=script&lang=js&"
import style0 from "./serviceContractMag.vue?vue&type=style&index=0&id=62c0f0bc&scoped=true&lang=css&"
import style1 from "./serviceContractMag.vue?vue&type=style&index=1&id=62c0f0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0f0bc",
  null
  
)

export default component.exports